export type SearchResult = SearchAddressResult | SearchIcadResult | Result;
import { Polygon as PolygonGJ } from 'geojson';

export const SearchAddressResultType = 'address';

export interface SearchAddressResult {
  type: typeof SearchAddressResultType;
  id: number;
  cidade: string;
  logradouro: string;
  bairro: string;
  cep: string;
  geom: { type: string; coordinates: [number, number] };
}

export const SearchIcadResultType = 'icad';

export type SearchIcadResult = {
  type: typeof SearchIcadResultType;
  id: number;
  insc: string;
  geo: PolygonGJ;
};

export const SearchGoogleResultType = 'google';

export interface GoogleAddressResponse {
  results: Result[];
  status: string;
}

export interface Result {
  type: typeof SearchGoogleResultType;
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: Geometry;
  place_id: string;
  types: string[];
}

export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface Geometry {
  location: Location;
  location_type: string;
  viewport: Viewport;
}

export interface Location {
  lat: number;
  lng: number;
}

export interface Viewport {
  northeast: Location;
  southwest: Location;
}
